import { cn } from "@/shared/lib/cn";

type ProfileAvatarProps = {
  initials: string;
  size?: number;
  className?: string;
  variant?: "default" | "sidebar";
  /** Logo ou photo : remplace les initiales quand il est présent. */
  src?: string | null;
};

export function ProfileAvatar({
  initials,
  size = 44,
  className,
  variant = "default",
  src,
}: ProfileAvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt=""
        aria-hidden
        className={cn("shrink-0 rounded-full bg-white object-contain outline outline-1 -outline-offset-1 outline-black/10", className)}
        // Marge proportionnelle à l'avatar (un pourcentage CSS se calculerait sur la largeur du parent).
        style={{ width: size, height: size, padding: Math.round(size * 0.08) }}
      />
    );
  }

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full font-semibold uppercase tracking-wide",
        variant === "sidebar"
          ? "bg-accent text-accent-foreground"
          : "bg-primary text-primary-foreground",
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.32)) }}
      aria-hidden
    >
      {initials}
    </div>
  );
}
